module.exports = __webpack_public_path__ + "img/wxnum.d3800bc4.jpg";